import { Component, OnInit, OnDestroy, AfterViewInit, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { MatSnackBar } from '@angular/material/snack-bar';
import { ProgressBarMode } from '@angular/material/progress-bar';

import {
  AnimationEditorComponent,
  AnimationService,
  C3Service,
  Color4,
  CuttingPlaneEditorComponent,
  IsoEditorComponent,
  IsoType,
  ModelService,
  ParticleTraceEditorComponent,
  ResultsConfigComponent,
} from '@usimweb/ceetron';
import * as fromStore from '@usimweb/state/store';

import { Projects } from '@usimweb/core/models';
import { Store } from '@ngrx/store';
import { Observable, skip, take } from 'rxjs';

@Component({
    selector: 'foaming-viewer',
    templateUrl: './viewer.component.html',
    styleUrls: ['./viewer.component.scss'],
    standalone: false
})
export class ViewerComponent implements OnInit, OnDestroy, AfterViewInit {
  private uuid: string = '';

  public isCompare: boolean = false;
  public isProgress: boolean = false;

  public project!: Projects;
  public projectId!: string;
  //public override isProgress: boolean = false;
  public progress: number = 0;
  public progressMode: ProgressBarMode = 'indeterminate';

  public isSetup: boolean = true;

  public solver: string = '';

  public IsoType = IsoType;

  @ViewChild(ResultsConfigComponent) private _resultsConfig!: ResultsConfigComponent;

  @ViewChild(CuttingPlaneEditorComponent) private _cuttingPlaneEditor!: CuttingPlaneEditorComponent;

  @ViewChild('isosurfaceEditor') private _isosurfaceEditor!: IsoEditorComponent;

  @ViewChild('isovolumeEditor') private _isovolumeEditor!: IsoEditorComponent;

  @ViewChild(ParticleTraceEditorComponent) private _particleTraceEditor!: ParticleTraceEditorComponent;

  @ViewChild(AnimationEditorComponent) private _animationEditor!: AnimationEditorComponent;

  public get animationTaskAlive() {
    return this.animationService.isAnimationTaskAlive;
  }

  public get animationBarOpen() {
    return this.modelService.animationBarOpen;
  }

  constructor(
    public store: Store<fromStore.DashboardState>,
    public c3Service: C3Service,
    public route: ActivatedRoute,
    public snackBar: MatSnackBar,
    private modelService: ModelService,
    private animationService: AnimationService
  ) {}

  ngOnInit(): void {
    this.uuid = this.route.snapshot.paramMap.get('id')?.toString()!;
    this.projectId = this.route.snapshot.paramMap.get('id2')?.toString()!;

    this.getProject();
  }

  ngAfterViewInit(): void {
    this.fullscreen();
    this.openModel();
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(event: Event) {
    this.fullscreen();
  }

  // add to base class
  ngOnDestroy(): void {
    // can be removed?
    // this.c3Service.setDefaultResult = true;
    // this.pointSelectionService.clearInjectionLocations();
    // this.store.dispatch(new fromStore.ClearVersions());
    // this.store.dispatch(new fromStore.ClearViewer());
    //this.removeModel();
  }

  private fullscreen() {
    const toolbarHeight = document.querySelector('.navbar')?.clientHeight ?? 0;
    const height = window.innerHeight - toolbarHeight;
    const width = window.innerWidth;

    this.c3Service._viewer['0'].resizeViewer(width, height);
    this.c3Service._view['0'].background.setSingleColor(new Color4(1, 1, 1, 1));
  }

  private openModel(): void {
    if (this.modelService.modelOpen) {
      this.modelService.taskPool[0].alive = true;
    }
    this.getToken();
  }

  private getToken() {
    this.store
      .select(fromStore.getToken)
      .pipe(skip(1), take(1))
      .subscribe((token) => {
        this.modelService.openModel(token as any, '0', this.animationService, true);
        this.modelService.scalarResult.subscribe((scalar) => {
          if (scalar) {
            // this.densityMapScalar = 'Density [node]';
            // this.setDensity();
          }
        });
      });
  }

  private getProject(): void {
    this.store
      .select(fromStore.getProjectById(this.projectId))
      // .pipe(take(2))
      .subscribe((project) => {
        if (project) {
          this.project = project;
        }
      });
  }

  public downloadFile(): void {
    //this.download();
  }

  public toggleView(event: any) {}

  public openCadDialog() {}

  public openAddCadDialog() {}

  public toggleResults() {
    this._resultsConfig.toggleVisibility();
  }
  public toggleCuttingPlane() {
    this._cuttingPlaneEditor.toggleVisibility();
  }

  public toggleIsosurface() {
    this._isosurfaceEditor.toggleVisibility();
  }

  public toggleIsovolume() {
    this._isovolumeEditor.toggleVisibility();
  }

  public toggleParticleTrace() {
    this._particleTraceEditor.toggleVisibility();
  }

  public toggleAnimation() {
    this._animationEditor.toggleVisibility();
  }
}
